import { render, staticRenderFns } from "./pincodes.vue?vue&type=template&id=1fa89857"
import script from "./pincodes.vue?vue&type=script&lang=js"
export * from "./pincodes.vue?vue&type=script&lang=js"
import style0 from "./pincodes.vue?vue&type=style&index=0&id=1fa89857&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports